{
	"loadingMessage": "Carregando contas...",
	"errorMessage": "Erro ao carregar dados",
	"emptyMessage": "Nenhuma conta encontrada",
	"noSearchResults": "Plano de contas não existe",
	"searchHint": "Procure por um plano de contas já cadastrado"
}
